import React from "react";
import type { FC, PropsWithChildren } from "react";

import cn from "classnames";

import type {
    PropsWithClassName,
    PropsWithTsId,
} from "../../../../../types/react";

import classes from "./MediaAddon.styl";

export interface IAddon
    extends PropsWithChildren,
        PropsWithTsId,
        PropsWithClassName {}

const Addon: FC<IAddon> = ({ children, className, "data-tsid": tsid }) => {
    const containerClass = cn(classes.addon, className);

    return (
        <div className={containerClass} data-tsid={tsid}>
            {children}
        </div>
    );
};

export default Addon;
